exports.init = function LoadingForm() {
  const selector = '.js-loading-form';
  const forms = $(selector);

  forms.on('submit', function(event) {
    const form = $(this);
    let container = form;


    // You have the option of pass the container selector instead
    // of using the form to show the overlay div
    if(form.data('loadingContainer')) {
      container = $(form.data('loadingContainer'));
    }

    container.overlay();

    try {
      if(container.valid()) {
        container.overlay('show');
      }
    } catch (error) {
      container.overlay('show');
    }

  });

};
